// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".digital-clock[data-v-9f2a4aa2]{font-size:3rem;width:100%;height:100%;justify-content:center;align-items:center;color:#fff;text-align:center}", ""]);
// Exports
module.exports = exports;
